// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.avatar-sm[data-v-db75bcfc] {\n  width: 56px;\n  border-radius: 50%;\n}\n.chat-message-type[data-v-db75bcfc] {\n  flex: 1 0 auto !important;\n}\n.profile-card[data-v-db75bcfc] {\n  margin-top: 100px;\n}\n.profile-card .avatar[data-v-db75bcfc] {\n  max-width: 150px;\n  max-height: 150px;\n  margin: -70px auto 0;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.btn-floating i[data-v-db75bcfc] {\n  color: #4f4f4f !important;\n}\n", ""]);
// Exports
module.exports = exports;
